import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { useCurrency } from '../contexts/CurrencyContext';
export function CTASection() {
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  return <section className="py-20 md:py-28 px-6 bg-base relative overflow-hidden" data-id="element-148">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-accent-primary/5 rounded-full blur-[120px] pointer-events-none" data-id="element-149" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-150">
        {/* Section label */}
        <FadeIn data-id="element-151">
          <div className="flex items-center gap-4 mb-16" data-id="element-152">
            <div className="h-px bg-border-accent flex-grow" data-id="element-153" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-154">
              ◆ Final Call ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-155" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-156">
          <h2 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-text-primary mb-8 leading-tight" data-id="element-157">
            The Story Must Be Told.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-158">
          <p className="font-body text-lg md:text-xl text-text-secondary mb-4 max-w-xl mx-auto" data-id="element-159">
            Some stories deserve more than 48 hours.
          </p>
          <p className="font-display text-2xl md:text-3xl font-bold text-text-primary mb-12" data-id="element-160">
            This one gets 170 pages.
          </p>
        </FadeIn>

        {/* Single powerful CTA block */}
        <FadeIn delay={0.3} data-id="element-161">
          <div className="bg-elevated border-2 border-accent-primary/40 rounded-sm p-10 md:p-14 shadow-gold-subtle" data-id="element-162">
            <p className="font-display text-xl md:text-2xl italic text-text-secondary mb-8" data-id="element-163">
              Be the person who knows the full story.
            </p>

            {/* Price reminder */}
            <div className="mb-6" data-id="element-164">
              <span className="font-body text-lg text-text-muted line-through mr-3" data-id="element-165">
                {isLoading ? '$47' : formatPrice(47)}
              </span>
              <span className="font-display text-4xl md:text-5xl font-bold text-accent-primary" data-id="element-166">
                {isLoading ? '$17' : formatPrice(17)}
              </span>
            </div>

            <Button href="https://www.mybetterlibrary.com/cart/42713853657165:1" className="w-full md:w-auto text-base md:text-lg px-12 py-5" data-id="element-167">
              Get The Memorial Edition &rarr;
            </Button>

            <p className="font-ui text-xs text-text-muted mt-5 tracking-wide" data-id="element-168">
              7-day money-back guarantee · Instant delivery · Yours forever
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-169">
          <p className="font-body text-sm italic text-text-muted mt-10" data-id="element-170">
            Memorial edition. Once it closes — it closes.
          </p>
        </FadeIn>
      </div>
    </section>;
}